function load(component) {
  return () => import(`@/views/${component}.vue`);
}
const Support = load('support/Support');
const QSupport = load('support/QSupport');
export default [
  {
    path: 'support',
    name: 'support',
    component: Support,
    meta: {
      requiresAuth: true,
      icon: 'gear',
      menuItems: 'leftSideMenu.support',
      newComponent: QSupport,
    },
  },
];
